import { z } from 'src/lib'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { schemaEntityWithId } from 'src/types'
import { getEndpointBySistema } from './httpSistema'
import { FileFields } from './file-fields'

const archivo = z
    .object({
        [FileFields.CodPath]: z.number(),
        [FileFields.Descripcion]: z.string(),
        [FileFields.Nombre]: z.string(),
        [FileFields.PathFisico]: z.string(),
        [FileFields.PathVirtual]: z.string()
    })
    .merge(schemaEntityWithId)

export const schema = z.array(archivo)

export type FileObjectWRC = z.infer<typeof archivo>
export type FileObjectsWRC = z.infer<typeof schema>

export const getArchivos = (idOperacion: number, codSistema: number): Promise<FileObjectWRC[]> => {
    const endpoint = `${getEndpointBySistema(codSistema)}/${idOperacion}/archivos`

    return HttpAxiosRequest.get(endpoint)
        .then(response => {
            const parsed = schema.safeParse(response)

            if (!parsed.success) {
                console.error(parsed.error.issues)

                return Promise.reject('Error de validación.')
            }

            return Promise.resolve(parsed.data)
        })
        .catch(error => {
            console.error(error)

            return Promise.reject('Error de red.')
        })
}
